import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';
import DocumentTitle from 'react-document-title';

import Panel from 'app/components/shared/Panel';
import permissions from 'app/lib/permissions';
import PageHeader from 'app/components/shared/PageHeader';
import Icon from 'app/components/shared/Icon';

import Row from './row';

class Index extends React.Component {
  static propTypes = {
    pipeline: PropTypes.shape({
      name: PropTypes.string.isRequired,
      schedules: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              id: PropTypes.string.isRequired,
              failedAt: PropTypes.string
            }).isRequired
          }).isRequired
        )
      }).isRequired,
      permissions: PropTypes.shape({
        pipelineScheduleCreate: PropTypes.shape({
          allowed: PropTypes.bool.isRequired
        }).isRequired
      }).isRequired
    }).isRequired,
    params: PropTypes.shape({
      organization: PropTypes.string.isRequired,
      pipeline: PropTypes.string.isRequired
    }).isRequired
  };

  render() {
    return (
      <DocumentTitle title={`Schedules · ${this.props.pipeline.name}`}>
        <React.Fragment>
          <PageHeader>
            <PageHeader.Icon>
              <Icon
                icon="schedules"
                style={{ width: 34, height: 34, marginTop: 3, marginLeft: 3 }}
              />
            </PageHeader.Icon>
            <PageHeader.Title>
              Schedules
            </PageHeader.Title>
            <PageHeader.Description>
              Build schedules automatically create builds at specified intervals.
            </PageHeader.Description>
            {this.renderNewScheduleButton()}
          </PageHeader>
          {this.renderFailureMessage()}
          <Panel>
            {this.renderScheduleRows()}
          </Panel>
        </React.Fragment>
      </DocumentTitle>
    );
  }

  renderFailureMessage() {
    const schedules = this.props.pipeline.schedules.edges;

    const failedSchedules = schedules.filter((edge) => edge.node.failedAt);

    const plural = failedSchedules.length !== 1;

    if (failedSchedules.length > 0) {
      return (
        <div className="mb4 p2 border border-red rounded red flex items-center">
          <span className="m1">
            {plural ? 'Several of your schedules have' : 'One of your schedules has'} been automatically disabled due to {plural ? 'errors' : 'an error'}.
          </span>
        </div>
      );
    }

    return null;
  }

  renderNewScheduleButton() {
    return (
      <PageHeader.Menu>
        {permissions(this.props.pipeline.permissions).check(
          {
            allowed: "pipelineScheduleCreate",
            render: () => <PageHeader.Button link={`/${this.props.params.organization}/${this.props.params.pipeline}/settings/schedules/new`} theme="primary">New Schedule</PageHeader.Button>
          }
        )}
      </PageHeader.Menu>
    );
  }

  renderScheduleRows() {
    const schedules = this.props.pipeline.schedules.edges;

    if (schedules.length > 0) {
      return schedules.map((edge) => {
        return (
          <Row key={edge.node.id} pipelineSchedule={edge.node} />
        );
      });
    }

    return (
      <Panel.Section>
        <p className="dark-gray">There are no schedules for this pipeline</p>
      </Panel.Section>
    );
  }
}

export default Relay.createContainer(Index, {
  fragments: {
    pipeline: () => Relay.QL`
      fragment on Pipeline {
        name
        schedules(first: 100) {
          edges {
            node {
              id
              failedAt
              ${Row.getFragment("pipelineSchedule")}
            }
          }
        }
        permissions {
          pipelineScheduleCreate {
            allowed
            code
            message
          }
        }
      }
    `
  }
});
